import {
  REQUEST_CROPS,
  RECIEVE_CROPS,
  SET_SELECT_SEASON,
  SET_SELECT_CROP
} from "./types";

export const initialState = {
  allCrops: [],
  selectedCropValue: -1,
  selectedSeason: -1
};

export const crops = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CROPS:
      return {
        ...state,
        allCrops:[],
        selectedCropValue: -1,
        selectedSeason:-1
      }
    case RECIEVE_CROPS:
      return {
        ...state,
        allCrops: action.payload,
      };
    case SET_SELECT_CROP:
      return {
        ...state,
        selectedCropValue: action.payload
      };
    case SET_SELECT_SEASON:
      return {
        ...state,
        selectedSeason: action.payload
      };
    default:
      return state;
  }
};

export default crops;
